/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type TaskListItemPriority = typeof TaskListItemPriority[keyof typeof TaskListItemPriority];


export const TaskListItemPriority = {
  urgent: 'urgent',
  high: 'high',
  medium: 'medium',
  low: 'low',
} as const;
